import { conn } from './conn';
import { GETLINKEDINLOGINURL, SIGNINURLLINKEDIN, CHECKTOKEN } from './urls';
import authModel from '../models/auth';

const getURLLinkedIN = async () => {
  const { data } = await conn().get(GETLINKEDINLOGINURL);
  return data;
}

const signInLinkedIN = async (queryParams) => {
  const { data } = await conn().get(SIGNINURLLINKEDIN + queryParams);
  /*
    token,
    firstName,
    lastName,
    email,
    profilePicture,
    linkedInId
  */

  if(data.message === 'Logged!') {
    return false;
  }
  authModel(data);
  return data;
}

const checkToken = async ()=>{
  console.log('++++++++++++++++++++++++++++++++++++++, checking login!');
  const auth=authModel();
  let ret;
  if(auth.token) {
    const { data } = await conn().get(CHECKTOKEN);
    ret=data;
  }
  return ret;
}

const doLogout = ()=>{
  const auth=authModel();
  auth.doLogout();
}

export {
  getURLLinkedIN,
  signInLinkedIN,
  doLogout,
  checkToken
}